import { Trans } from '@lingui/macro'
import classNames from 'classnames'
import { ReactNode } from 'react'

import { ArrowProps, LastViewedProducts } from './LastViewedProducts'
import { MarginArea } from './MarginArea'
import styles from './RecentlyViewedProducts.module.scss'
import {
    RecentlyViewedProduct,
    useLastViewedProducts,
} from '../catalog/lastViewedProducts.query'
import NextIcon from '../core/NextIcon'
import Button from '../input/Button'
import Col from '../layout/Col'
import Container from '../layout/Container'
import Row from '../layout/Row'
import Loader from '../presentation/Loader'
import Heading from '../typography/Heading'

interface Props {
    header?: ReactNode
    productFilter?: (product: RecentlyViewedProduct) => boolean
}

export const RecentlyViewedProducts = ({ header, productFilter }: Props) => {
    const { loading, products } = useLastViewedProducts()

    if (loading) {
        return <Loader />
    }

    if (!products || !products?.length) {
        return null
    }

    const filteredProducts =
        productFilter && typeof productFilter === 'function'
            ? products.filter(productFilter)
            : products

    if (!filteredProducts || !filteredProducts.length) {
        return null
    }

    return (
        <Container noPadding>
            <Row noGutters>
                {header}
                {!header && (
                    <Heading variant="h4" element="span">
                        <Trans id="account.overview.lastviewed.header">
                            Last viewed
                        </Trans>
                    </Heading>
                )}
            </Row>
            <MarginArea bottom xs />

            <Row noGutters>
                <Col>
                    <LastViewedProducts
                        nextArrow={(props: ArrowProps) => (
                            <Button
                                variant="duskAlt"
                                name="next"
                                category="lastviewed.products"
                                onClick={props.handleClick}
                                disabled={props.isDisabled}
                                className={classNames(
                                    styles.nav,
                                    styles.button,
                                    props.isDisabled ? styles.disabled : '',
                                )}
                            >
                                <div className={styles.caret}>
                                    <NextIcon />
                                </div>
                            </Button>
                        )}
                        prevArrow={(props: ArrowProps) => (
                            <Button
                                variant="duskAlt"
                                name="previous"
                                category="lastviewed.products"
                                onClick={props.handleClick}
                                disabled={props.isDisabled}
                                className={classNames(
                                    styles.nav,
                                    styles.button,
                                    props.isDisabled ? styles.disabled : '',
                                )}
                            >
                                <div
                                    className={classNames(
                                        styles.caret,
                                        styles.prev,
                                    )}
                                >
                                    <NextIcon />
                                </div>
                            </Button>
                        )}
                        products={filteredProducts}
                    />
                </Col>
            </Row>
        </Container>
    )
}
